import type { ThumbnailOwner } from '@pb/shared';
import { post } from './client';

export const retryThumbnails = (ownerType: ThumbnailOwner, ownerId: number) =>
  post<unknown>(`/thumbnails/${ownerType}/${ownerId}/retry`, {});
